import { useDelayedFlag } from '@/shared/hooks';

export const DEFAULT_DEFERRED_ASYNC_VIEW_DELAY_MS = 200;

export type DeferredAsyncViewPhase = 'placeholder' | 'skeleton' | 'error' | 'empty' | 'ready';

export const resolveDeferredAsyncViewPhase = ({
  loading,
  delayedLoading,
  hasError = false,
  isEmpty = false,
}: {
  loading: boolean;
  delayedLoading: boolean;
  hasError?: boolean;
  isEmpty?: boolean;
}): DeferredAsyncViewPhase => {
  if (loading) {
    return delayedLoading ? 'skeleton' : 'placeholder';
  }

  if (hasError) {
    return 'error';
  }

  if (isEmpty) {
    return 'empty';
  }

  return 'ready';
};

export const useDeferredAsyncViewState = ({
  loading,
  hasError = false,
  isEmpty = false,
  delayMs = DEFAULT_DEFERRED_ASYNC_VIEW_DELAY_MS,
}: {
  loading: boolean;
  hasError?: boolean;
  isEmpty?: boolean;
  delayMs?: number;
}): {
  phase: DeferredAsyncViewPhase;
  showPlaceholder: boolean;
  showSkeleton: boolean;
  showError: boolean;
  showEmpty: boolean;
  showReady: boolean;
} => {
  const delayedLoading = useDelayedFlag(loading, delayMs);
  const phase = resolveDeferredAsyncViewPhase({
    loading,
    delayedLoading,
    hasError,
    isEmpty,
  });

  return {
    phase,
    showPlaceholder: phase === 'placeholder',
    showSkeleton: phase === 'skeleton',
    showError: phase === 'error',
    showEmpty: phase === 'empty',
    showReady: phase === 'ready',
  };
};
